import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { capitalize } from '@material-ui/core/utils'

import ImageContainer from '../ImageContainer'

import { PreviewPrice } from './PriceWithDiscount/index'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(3.5),
    },
  },
  imageWrapper: {
    borderRadius: 2,
    overflow: 'hidden',
    marginRight: theme.spacing(2),
    minWidth: ({ ratio }) => 130 * ratio,
    [theme.breakpoints.down('md')]: {
      minWidth: ({ ratio }) => 60 * ratio,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: ({ ratio }) => 70 * ratio,
    },
  },
  image: {
    maxHeight: '100%',
    width: 'auto',
    objectFit: ({ cover }) => (cover ? 'cover' : 'fit'),
  },
  information: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.5, 0),
    },
  },
  title: {
    lineHeight: 1.2,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.125rem',
    },
  },
  price: {
    fontSize: '1rem',
    whiteSpace: 'nowrap',
    fontWeight: 600,
    color: '#202126',
  },
  spacer: {
    flexGrow: 1,
  },
  qty: {
    padding: '0',
    justifySelf: 'flex-end',
  },
  membershipPlan: {
    fontSize: '.825rem',
    color: theme.palette.secondary.main,
  },
  effective: {
    fontWeight: 500,
    marginTop: theme.spacing(1),
  },
}))

const OrderProductPreview = ({ image, title, price, children, ratio, fullPriceInfo, qty }) => {
  const classes = useStyles({ ratio })
  return (
    <div className={classes.container}>
      <div className={classes.imageWrapper}>
        <ImageContainer src={image} className={classes.image} ratio={ratio} loading='eager' />
      </div>

      <div className={classes.information}>
        <Box display='flex' justifyContent='space-between' alignItems='flex-start'>
          <Typography variant='h5' className={classes.title}>
            {capitalize(title)}
          </Typography>
          {fullPriceInfo?.base_price ? (
            <PreviewPrice qty={qty} fullPriceInfo={fullPriceInfo} />
          ) : (
            <Box display='flex'>
              <Typography variant='body2' classes={{ root: classes.price }}>
                {price}
              </Typography>
            </Box>
          )}
        </Box>
        {children}
      </div>
    </div>
  )
}

OrderProductPreview.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  price: PropTypes.node,
  children: PropTypes.node,
  ratio: PropTypes.number,
  qty: PropTypes.number,
  fullPriceInfo: PropTypes.shape({
    base_price: PropTypes.number,
    promo_discount_details: PropTypes.shape({
      discount_method: PropTypes.string,
      amount: PropTypes.number,
    }),
    total: PropTypes.number,
    before_discount: PropTypes.number,
    promo_discount: PropTypes.number,
  }),
}

OrderProductPreview.defaultProps = {
  ratio: 4 / 3,
}

export default OrderProductPreview
